import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Icon from "material-ui-next/Icon";
import Tooltip from "material-ui-next/Tooltip";
import Typography from "material-ui-next/Typography";

import {
  CheckBox,
  SelectField,
  TextField,
  Loadable,
  StyledButton,
  If
} from "components/support";

import style from "./style";

import PendingTransactions from "./pending-transactions";

class MyFinanceIntegration extends Component {
  showPendingTransactions = () => {
    const { presenter, viewModel } = this.props;
    const { pendingTransactionsOpen, company } = viewModel;
    const { token, account_id, entity_id } = company.integrations.my_finance;

    return (
      <PendingTransactions
        pendingTransactionsOpen={pendingTransactionsOpen}
        token={token}
        accountId={account_id}
        entityId={entity_id}
        onPendingTransactionsClose={() =>
          presenter.onPendingTransactionsClose()
        }
      />
    );
  };

  render() {
    const { className, presenter, viewModel } = this.props;
    const {
      loading,
      accounts,
      entities,
      company,
      pendingTransactionsOpen
    } = viewModel;
    const {
      enabled,
      token,
      account_id,
      entity_id
    } = company.integrations.my_finance;

    return (
      <div className={`${className} grid-container mt-sm`}>
        <Loadable loading={loading}>
          <Typography type="headline">MyFinance</Typography>

          <span className="subheading-style">
            O Myfinance é o sistema online ideal para a gestão financeira da sua
            empresa. É uma ferramenta extremamente eficiente no controle das
            finanças e de fácil utilização.
          </span>
          <span className="subheading-style mt-sm">
            Além de agilizar seus processos e reduzir seus custos, o Myfinance
            possibilita que você faça a Gestão Financeira da sua empresa em
            tempo real, auxiliando no controle e desenvolvimento do seu negócio.
          </span>

          <hr />

          <Row bottom="xs">
            <Col xs={12} md={8}>
              <div className="integration-status">
                <CheckBox
                  checked={enabled}
                  style={{ paddingLeft: 4 }}
                  label="Status Integração"
                  onCheck={checked => presenter.manageCheckbox(checked)}
                />
                <div className="tooltip">
                  <Tooltip
                    key="tooltip-top-myfinance"
                    title="Assinale para ativar/desativar a integração com o MyFinance"
                    placement="top"
                  >
                    <Icon className="tooltip-icon">info</Icon>
                  </Tooltip>
                </div>
              </div>
            </Col>
            <Col xs={12} md={4}>
              <StyledButton
                accent
                label="Transações não sincronizadas"
                onClick={() => presenter.onPendingTransactionsOpen()}
              />
              <If test={pendingTransactionsOpen}>
                {this.showPendingTransactions()}
              </If>
            </Col>
          </Row>

          <Row>
            <Col xs={12}>
              <TextField
                fullWidth
                label="Token do MyFinance"
                value={token}
                onChange={(_, value) => presenter.setToken(value)}
                style={{ marginTop: 0 }}
                maxLength={48}
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} md={6}>
              <SelectField
                fullWidth
                label="Selecione a conta a ser integrada"
                disabled={accounts.length === 0 && account_id === ""}
                value={account_id}
                onChange={(_, value) => presenter.setAccount(value)}
                options={accounts.map(account => {
                  return {
                    value: account.id,
                    label: account.name
                  };
                })}
              />
            </Col>
            <Col xs={12} md={6}>
              <SelectField
                fullWidth
                label="Selecione a entidade a ser integrada"
                disabled={entities.length === 0 && entity_id === ""}
                value={entity_id}
                onChange={(_, value) => presenter.setEntity(value)}
                options={[
                  { id: "", name: "Selecione uma Entidade" },
                  ...entities
                ].map(entity => {
                  return {
                    value: entity.id,
                    label: entity.name
                  };
                })}
              />
            </Col>
          </Row>
        </Loadable>
      </div>
    );
  }
}

export default style(MyFinanceIntegration);



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/my-finance/view.jsx